import React from 'react';
import {
  Routes,
  Route,
} from "react-router-dom";
import { AppWrapper } from "./styles/app";
import { pageRoutes } from './routes/allRoutes';
import Navbar from './components/Navbar';
import Header from './components/Header';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.css';

const App: React.FC = () => {
  return (
    <AppWrapper>
      <header id='pageHeader'>
        <Header />
      </header>
      <article id='pageArticle'>
        <Routes>
          {pageRoutes.map((route, key) => (
            <Route key={key} path={route.path} element={route.component} />
          ))}
        </Routes>
      </article>
      <ToastContainer autoClose={2000} />
    </AppWrapper>
  );
}

export default App;
